export const environment = {
    production: false,
    i18nVersion: '2026.05.07',
    authUrl: 'https://dev-auth.jmbiomedica.com.co',
    clientId: 'jmbiomedica-ui',
    clientSecret: 'simplified',
    redirectUri: 'https://dev-gestion.jmbiomedica.com.co/callback',
    postLogoutRedirectUri: 'https://dev-gestion.jmbiomedica.com.co/',
    apiUrl: 'https://dev-gestion-api.jmbiomedica.com.co',
    scope: 'openid person:read person:write role:read role:write permission:read permission:write scope:read scope:write client:read client:write manufacturer:read manufacturer:write users client_jm:read client_jm:write sites file:read file:write file:read_admin catalogs:read catalogs:write techrecord:read techrecord:write equipment equipment:read equipment:write vendor:read vendor:write schedule maintenance takeout report:read report:read_admin',
};
